import {
    Link,
    Pivot, PivotItem,
    PrimaryButton,
    Stack,
} from "@fluentui/react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AddEditOneDaySaleDialog } from "components/dialogs/dealTrackerDialog/oneDaySaleAppraisalDialog/AddEditOneDaySaleDialog";
import { EditActivateDeactivateActionsSubmenu } from "components/table/dropdowns/EditActivateDeactivateActionsSubmenu";
import { alloneDaySaleDate, colors, emplyeePermissionsAction } from "constants/constants";
import { EmployeeActionPermission } from "hoc/withCredentials";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Paginator } from "primereact/paginator";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppState } from "store";
import { handleDeleteOneDaySaleDate, handleGetOneDaySaleDate } from "store/oneDaySale/oneDaySale.action";
import { convertUTCToLocalDateOnlyModified } from "utils/dateTimeFunctions";
import { isEmployeePermitted, isKarlProfile } from "utils/permissions/permissionsHelpers";

export const OneDaySaleSettingPage = () => {
    const navigate = useNavigate();
    const serverError = useSelector((state: AppState) => state.selectList.error) as any;
    const user = useSelector((state: AppState) => state.userProfile.userProfile);
    const [permission, setPermission] = useState('');
    const border = {
        borderTop: `2px solid ${colors.separator}`,
        width: "100% !important",
        display: "block !important"
    };

    const [commonServerError, setcommonServerError] = useState(null);
    const [isOpenListDialog, setIsOpenDialog] = useState(false);
    const [data, setData] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState(false);
    const [sortField, setSortField] = useState('oneDaySale.saleDate');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [dateOrder, setDateOrder] = useState(1);
    const oneDaySaleDate = useSelector(
        (state: AppState) => state.oneDaySale.oneDaySaleDate
    );
    const [tableData, setTableData] = useState([]);

    const [totalRecords, setTotalRecords] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);


    useEffect(() => {
        setPermission((emplyeePermissionsAction.SETTING_ONE_DAY_SALE?.toString()));
        setcommonServerError('');

    }, []);// eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        fetchSaleDate();
    }, [dispatch, sortOrder, sortField, page, limit, dateOrder]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (oneDaySaleDate?.results?.results?.length) {
            setCurrentPage(oneDaySaleDate?.results?.currentPage);
            setTotalRecords(oneDaySaleDate?.results.totalItems)
            setTableData(oneDaySaleDate?.results.results);

        } else {
            setTableData([])
        }
    }, [oneDaySaleDate]);// eslint-disable-line react-hooks/exhaustive-deps

    const fetchSaleDate = useCallback(() => {
        dispatch(
            handleGetOneDaySaleDate({
                formData: {
                    page: page ? page : 1,
                    limit: limit,
                    column: sortField,
                    sort: sortOrder ? 'DESC' : 'ASC',
                    dateOrder: dateOrder,
                    allSaleDate:alloneDaySaleDate.futurePastDate.key,
                }
            })
        );
    }, [dispatch, page, limit, sortOrder, sortField, dateOrder]);// eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (user.profileType && !isKarlProfile(user.profileType)) {
            navigate('/dashboard');
        }
    }, [user]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (serverError) {
            setcommonServerError('Failed to Fetch the Data');
            window.scrollTo(0, 0);
        }
        else {
            setcommonServerError(null);
        }
    }, [serverError]);

    const dateAddedBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <span className="p-column-title">One Day Sale Date</span>
                {convertUTCToLocalDateOnlyModified(rowData.saleDate)}
            </React.Fragment>
        );
    };
    const pastdateAddedBodyTemplate = (rowData) => {


        return (
            <React.Fragment >
                <span className="p-column-title" >One Day Sale Date</span>
                <div style={{ textAlign: 'left' }}>{convertUTCToLocalDateOnlyModified(rowData.saleDate)}</div>
            </React.Fragment>
        );
    };

    const handleSelectListItemActivateDeactivate = (id, isActive) => {
        dispatch<any>(
            handleDeleteOneDaySaleDate(
                {
                    id: id,
                    callback: (res, error) => {
                        if (res) {
                            fetchSaleDate();
                            setcommonServerError('');
                        } else {
                            setcommonServerError("Failed to delete the sale date")
                        }
                    }
                })
        );

    };

    const settingBodyTemplate = useCallback((rowData) => {
        return (
            <React.Fragment>
                {/*<span className="p-column-title" style={{ float: "left" }}>Actions</span>*/}
                { user.roles && (

                    <EmployeeActionPermission
                        permissionList={user.aggregatedDefaultPolicies}
                        alias={permission}
                        roles={user.roles}
                    >
                        <EditActivateDeactivateActionsSubmenu
                            itemId={rowData.id}
                            isAppraisal={true}
                            isActive={true}
                            onActivateDeactivate={(id, isActive) => handleSelectListItemActivateDeactivate(id, isActive)}
                            onEdit={(id) => handleEdit(id)}
                            updatePermission={user && isEmployeePermitted(user.aggregatedDefaultPolicie, permission, user.roles)}
                            deletePermission={user && isEmployeePermitted(user.aggregatedDefaultPolicie, permission, user.roles)}
                        />
                    </EmployeeActionPermission>
                )}


            </React.Fragment>
        );
    },[user,permission,oneDaySaleDate?.results?.results]);// eslint-disable-line react-hooks/exhaustive-deps

    const navigatetoOpenListDialog = () => {
        setData(null);
        setEditData(null);
        setcommonServerError('');
        setIsOpenDialog(true);
    }

    const handleDialogDismiss = () => {
        fetchSaleDate();
        setData(null);
        setEditData(null);
        setIsOpenDialog(false);
    };


    const onPageChange = (event) => {
        setCurrentPage(event.first);
        setPage(event.page + 1);
        setLimit(event.rows);
    }

    const footer = (
        <>
            <Paginator first={Number(currentPage)} rows={limit} totalRecords={Number(totalRecords)} rowsPerPageOptions={[25, 50, 100]} onPageChange={onPageChange}></Paginator>
        </>
    );

    const handleColumnSort = (e) => {
        setSortField(e.sortField);
        setSortOrder(!sortOrder);
    }

    const handleRowClick = (event) => {
        let target = event.originalEvent.target;
        if (target.nodeName === 'TD' && target.hasChildNodes() && target.lastElementChild.nodeName === 'BUTTON') {
            target?.lastElementChild?.lastElementChild?.firstElementChild.click();
        } else {
            setEditData(event.data.id);
            setIsOpenDialog(true);
        }
       // setIsOpenDialog(false);
    };


    const handleEdit = useCallback((value: any) => {
        setEditData(value);
        setIsOpenDialog(true);
    },[tableData,oneDaySaleDate?.results?.results,setIsOpenDialog,setData]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isOpenListDialog && editData){
            const result = oneDaySaleDate?.results.results.find(item => item.id === editData);
            setData(result);
        }else{
            setData(null);
            setEditData(null);
        }
    },[isOpenListDialog,tableData,editData]);// eslint-disable-line react-hooks/exhaustive-deps

    return (

        <>
            {
                isOpenListDialog &&
                <AddEditOneDaySaleDialog
                    formData={data}
                    title={'One Day Sale Date'}
                    onDismiss={() => handleDialogDismiss()}
                />
            }

            <Stack tokens={{ childrenGap: 10 }}>
                <Row className="user-edit-section">
                    <Col>
                        <Row style={{ marginTop: "25px" }}>
                            <Col>
                                <Link onClick={() => { navigate('/dashboard') }}><ArrowBackIcon /><span className="arrow-back-text">Back</span></Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="alignHeaders">
                                <span className="pageTitleFont pageName">One Day Sales</span>
                            </Col>
                        </Row>
                        {
                                commonServerError ?
                                    <div>
                                        <p className="genericErrorColor"><span>{commonServerError}</span></p>
                                    </div> : null
                            }
                        <Row className="rowPaddingBtwSpace">
                            <Col>
                                <Pivot
                                    style={{ padding: 0, margin: 0 }}
                                    className="pivotItem delar-body"
                                    defaultSelectedKey="2"
                                    onLinkClick={(item?: any) => {
                                        setTableData([]);
                                        setLimit(25);
                                        setPage(1);
                                        if (item.props.headerText === 'Past Dates') {
                                            setDateOrder(0);
                                        } else {
                                            setDateOrder(1);
                                        }
                                        setcommonServerError('');
                                    }}
                                >
                                    <PivotItem
                                        className="pivotItem"
                                        style={border}
                                        headerText="Future Dates"
                                        onClick={() => { setDateOrder(1) }}
                                        headerButtonProps={{
                                            "data-order": 1,
                                            "data-title": "User Details",
                                        }}
                                    >
                                        <div>
                                            <Row className=" margin-12-0">
                                                <Col className="user-action">
                                                    {user.roles && (
                                                        <EmployeeActionPermission
                                                            permissionList={user.aggregatedDefaultPolicies}
                                                            alias={permission}
                                                            roles={user.roles}
                                                        >
                                                            <PrimaryButton
                                                                text="Add Selection"
                                                                className="float-left"
                                                                onClick={navigatetoOpenListDialog}
                                                            />
                                                        </EmployeeActionPermission>
                                                    )}
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="datatable-filter-demo">
                                            <div className="card" style={{ width: '70%' }}>

                                                <DataTable
                                                    value={tableData}
                                                    paginator={false}
                                                    footer={footer}
                                                    sortField={sortField}
                                                    //sortOrder={sortOrder}
                                                    onSort={handleColumnSort}
                                                    lazy
                                                    className="p-datatable-customers"
                                                    emptyMessage="No Future Dates found."
                                                    onRowClick={(event) => handleRowClick(event)}
                                                >
                                                    <Column sortable field="oneDaySale.saleDate" header="Sale Date" body={dateAddedBodyTemplate} />
                                                    <Column field="Settings" style={{ width: '10em' }} header="Actions" body={settingBodyTemplate} />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </PivotItem>
                                    <PivotItem
                                        className="pivotItem"
                                        style={border}
                                        headerText="Past Dates"
                                        onClick={() => { setDateOrder(0) }}
                                        headerButtonProps={{
                                            "data-order": 1,
                                            "data-title": "Inactive",
                                        }}
                                    >
                                        <div className="datatable-filter-demo ">
                                            <div className="card" style={{ width: '70%', marginTop: '20px' }}>
                                                <DataTable
                                                    value={tableData}
                                                    paginator={false}
                                                    footer={footer}
                                                    sortField={sortField}
                                                    //sortOrder={sortOrder}
                                                    onSort={handleColumnSort}
                                                    lazy
                                                    className="p-datatable-customers"
                                                    emptyMessage="No Past Dates found."
                                                >
                                                    <Column sortable field="oneDaySale.saleDate" header="Sale Date" body={pastdateAddedBodyTemplate} />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </PivotItem>
                                </Pivot>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Stack>
        </>)
};

